"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentGameTypeToJSON = exports.TournamentGameTypeFromJSONTyped = exports.TournamentGameTypeFromJSON = exports.TournamentGameType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var TournamentGameType;
(function (TournamentGameType) {
    TournamentGameType["REGULAR"] = "REGULAR";
    TournamentGameType["MODIFIED1"] = "MODIFIED1";
    TournamentGameType["MODIFIED2"] = "MODIFIED2";
    TournamentGameType["MODIFIED3"] = "MODIFIED3";
})(TournamentGameType = exports.TournamentGameType || (exports.TournamentGameType = {}));
function TournamentGameTypeFromJSON(json) {
    return TournamentGameTypeFromJSONTyped(json, false);
}
exports.TournamentGameTypeFromJSON = TournamentGameTypeFromJSON;
function TournamentGameTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TournamentGameTypeFromJSONTyped = TournamentGameTypeFromJSONTyped;
function TournamentGameTypeToJSON(value) {
    return value;
}
exports.TournamentGameTypeToJSON = TournamentGameTypeToJSON;
